// extracted by mini-css-extract-plugin
export default {"breadcrumbText":"Breadcrumb_breadcrumbText__PREMX","active":"Breadcrumb_active__Hhwe9"};